import React, { FunctionComponent, useState } from "react"
import { Card } from "react-bootstrap"
import { CenterLayout } from "../../presentationals/layouts/center"
import { Trans, withTranslation, WithTranslation } from "react-i18next"
import { useParams } from 'react-router-dom';

import styles from "./friend-code.module.scss"

const FriendCode: FunctionComponent<WithTranslation> = ({
    t,
}: WithTranslation) => {
    const { code } = useParams<{ code: string }>();
        const [copied, setCopied] = useState(false);
        const handleCopy = () => {
            if (code) {
                navigator.clipboard.writeText(code)
                    .then(() => {
                        setCopied(true);
                        setTimeout(() => setCopied(false), 1500);
                    });
            }
        };

    return (
        <CenterLayout>
            <Card className={styles.card}>
                <Card.Body className={styles.cardBody}>
                    <img
                        className={styles.logo}
                        src={String(
                            new URL("../../assets/logo.svg", import.meta.url)
                        )}
                        alt="Anio Logo"
                    />
                    <div className={styles.heading}>
                        <h1>
                            <Trans>friend_code.title</Trans>
                        </h1>
                        <hr></hr>
                    </div>

                    <Trans>friend_code.description</Trans>
                    
                    {code && (
                        <>
                            <div className={styles.friendCode}>
                                {code}
                            </div>
                            <button
                                className={styles.copyButton}
                                onClick={handleCopy}
                                style={{ marginTop: '1rem' }}
                            >
                                <Trans>friend_code.copy_code</Trans>
                            </button>
                            {copied && (
                                <div style={{ color: 'green', marginTop: '0.5rem' }}>
                                    <Trans>friend_code.code_copied</Trans>
                                </div>
                            )}
                        </>
                    )}
                </Card.Body>
            </Card>
        </CenterLayout>
    )
}

export default withTranslation()(FriendCode)
